import { Component, Inject, OnInit } from '@angular/core';
import { Subscription, throwError} from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LogoService } from '../../services/logo.service';
import {FormControl , Validators} from '@angular/forms';
import E from 'wangeditor'
import i18next from 'i18next'

@Component({
  selector: 'app-table-edit',
  templateUrl: './table-edit.component.html',
  styleUrls: ['./table-edit.component.scss']
})
export class TableEditComponent implements OnInit {

  private logosData$: Subscription;
  logosData:any;
  config = {
  toolbar: [
    //['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    //[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    //[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    //[{ 'direction': 'rtl' }],                         // text direction

    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    //[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    //[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    //[{ 'font': [] }],
    //[{ 'align': [] }],

    //['clean'],                                         // remove formatting button

    ['link']                         // link and image, video
  ]
};
  isRichText = true;
  tempTopic = "";
  public dropDownItems = {};
  public isReadOnly:boolean=false;
  editor: any;
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<TableEditComponent>,    
    @Inject(MAT_DIALOG_DATA) public data: any,
    public logoService: LogoService
  ) { }

  public requiredFormControl = new FormControl('', [
    Validators.required,
    ]);
  ngOnInit(): void {

            // wire up the logos
            if(this.data.tableDef.title !== 'FAQs'){
              this.logosData$ = this.logoService.logos$.subscribe(
              (responsedata: any) => {
                if(responsedata!=null){                  
                  if(responsedata.loading){
                  } else {
                    // special case for the logo - assume field is called logo and add to the drop downs
                    let tmp = [];
                    responsedata["data"].forEach(x => {
                      tmp.push({'value':x.name,'label':x.name})
                    });
                    this.dropDownItems["logo"] = tmp;
                  }
                }
              }
            )
            if(this.logosData==undefined) this.logoService.loadLogos();
            }
            

      if((this.data.tableDef["readOnly"] && this.data.tableDef["readOnly"]===true)||(this.data.data["isdeleted"]&&this.data.data["isdeleted"]===true)){
          this.isReadOnly = true;
      }

    // Go through the definition and do any preprocessing
    // 1) Generate the drop down value arrays
    this.data.tableDef.fields.forEach(item => {
      if(item.type=="dropdown" && !(item.readonly && item.readonly === true)){
        this.dropDownItems[item.name] = this.getDropDownItems(item);
        if(item.parent&&this.data.data!={}){
          this.dropDownItems[item.name] =  this.dropDownItems[item.name].filter(x => (x["parentId"]==this.data.data[item.parent]||x["parentName"]==this.data.data[item.parent]));;
        }else if(item.parent&&this.data.data=={}){
          this.dropDownItems[item.name] = [];
        }
      }      
    });
  }

  ngAfterViewInit():void{
    if(this.data.tableDef.title == 'FAQs'){
       this.initRichText()
    }
  }
  initRichText(){
    if(this.isRichText){
      this.editor = new E('#editorTest');
      this.editor.config.height = 150
      this.editor.config.zIndex = 1049
      this.editor.i18next = i18next
      this.editor.config.lang = 'en'
      this.editor.config.menus = [
        'head',
        'bold',
        'fontSize',
        'italic',
        'underline',
        'strikeThrough',
        'indent',
        'foreColor',
        'backColor',
        'link',
        'list',
        'table'
    ]
      this.editor.config.onchange = (newHtml) => {
        this.data.data['answer'] = newHtml;
      };
      this.editor.create();
      this.editor.txt.html(this.data.data['answer'] || '');
    }
  }
  getType(item){
    if(this.isReadOnly){
      return "readonly";
    }
    if(item["readonly"] && item["readonly"]===true){
      return "readonly";
    } else if(item["type"]=="dropdown") {
      return "dropdown"
    }else {
      return "string"
    }
  }

  // sort out the values option of the dropdown - allow simple array or array of objects with label and value properties - if
  // label is missing use the value
  getDropDownItems(item){

    let rtn = [];
    let vals = item.values
    if(Array.isArray(vals)){
      vals.forEach(x => {
        if(!(item.name == "parentid"&&this.data.data.id == x["value"])){
          if(typeof x === 'object'){
            if(x.parentId){
              rtn.push(x);
            }else{
              rtn.push({value:x["value"],label:x["label"]?x["label"]:x["value"]})
            }
          } else {
            rtn.push({'value':x,'label':x})
          }
        }
      });      
    }

    //console.log("--" + JSON.stringify(rtn))
    return rtn;

  }

  onChange(item){
    if(item.child){
      let child = this.data.tableDef.fields.filter(x => (x.name == item.child))[0];
      this.dropDownItems[item.child] =  child.values.filter(x => (x["parentId"]==this.data.data[item.name]));
      if(this.data.data[item.child]){
        let selectedItem = child.values.filter(x => (x["value"]==this.data.data[item.child]));
        if(selectedItem.parentId!=this.data.data[item.name]){
          delete this.data.data[item.child];
        }
      }
    }
  }

  save():void{
      let isRequired = this.data.tableDef.fields.filter(x => (x.isRequired && x.isRequired == true));
      let warningMes = '';
      let isAlert = false;
      if(isRequired.length > 0){
        isRequired.forEach(ele => {
          if(JSON.stringify(this.data.data)!=='{}'){
            let isFind = false;
            for(let key in this.data.data){
              if(key == ele['name'] && this.data.data[key] ){
                isFind = true;
                return false;
              }
           }
           if(!isFind){
                isAlert = true;
                if(ele['label']==='Client Id'){
                  warningMes+=`"${ele['label']}" is required, and should be numeric!\n`
                }else{
                  warningMes+=`"${ele['label']}" is required!\n`
                }
                document.getElementById(ele['label']).style.borderColor='red';
           }
          }else{
            isAlert = true;
            if(ele['label']==='Client Id'){
              warningMes+=`"${ele['label']}" is required, and should be numeric!\n`
            }else{
              warningMes+=`"${ele['label']}" is required!\n`
            }
            document.getElementById(ele['label']).style.borderColor='red';
          }
        });
}
if(isAlert){
  alert(warningMes);
}else{
  this.dialogRef.close({...this.data.data});
}
  }

  close(){     
      this.dialogRef.close("cancel");
  }
  changeBorderColor(data,key){
    if(data){
      console.log(data);
      document.getElementById(key).style.borderColor='rgba(0, 0, 0, 0.25)';
    }else{
      document.getElementById(key).style.borderColor='red';
    }
  }
  delete(){
    const dialogRef = this.dialog.open(OKCancelDialog, {
      width: '350px',
      data: {title:"Confirm", text: "Are you sure you want to delete this record?"}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result=="ok"){
        this.dialogRef.close("delete");
      }      
    });
  }
  softDelete(){
    this.data.data.isdeleted = true;
    this.save();
  }
  active(){
    this.data.data.isdeleted = false;
    this.save();
  }
  getItem(name:string){
    for(let temp of this.data.tableDef.fields){
      if(temp.name === name){
        return temp;
      }
    }

  }
 
  stopEvent(event){
    event.stopPropagation();
  }
  ngOnDestroy(){
    if(this.data.tableDef.title == 'FAQs'){
      this.editor.destroy();
      this.editor = null;
    }
  }
  changeTextInput(){
    this.isRichText = !this.isRichText
    setTimeout(()=>{this.initRichText()}, 100)
  }
  formatDate(d) {
    if(d){
      let date = new Date(d);
      let YY = date.getFullYear() + '-';
      let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return YY + MM + DD +" "+hh + mm + ss;
    }else{
      return "";
    }
  }
}



// TODO - put this as a seperate component - bound to need it
@Component({
  selector: 'okcanceldialog',
  styleUrls: ['./table-edit.component.scss'],
  template: `<h3 class="mat-dialog-title aip-dialog-title">{{data.title}}</h3>
  <div class="mat-dialog-content aip-dialog-text">
    {{data.text}}
</div>
  <div class="mat-dialog-actions" align="end">
    <button class="mat-focus-indicator aip-button mat-raised-button mat-button-base mat-primary" (click)="ok()">OK</button>
    <button class="mat-focus-indicator aip-button-alt mat-raised-button mat-button-base" (click)="cancel()" cdkFocusInitial>Cancel</button>
</div>
    `
})
export class OKCancelDialog {

  constructor(
    public dialogRef: MatDialogRef<OKCancelDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ok(): void {
      this.dialogRef.close("ok");
    }

  cancel(): void {
    this.dialogRef.close("cancel");
  }
}
